import React from 'react';
import { makeStyles, Box, Typography, Button } from '@material-ui/core';
import StarsIcon from '@material-ui/icons/Stars';
import FlashOnIcon from '@material-ui/icons/FlashOn';

const useStyles = makeStyles((theme) => ({
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90%',
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  actionCard: {
    maxWidth: 400,
    padding: theme.spacing(3),
    backgroundColor: '#f8fafc',
    borderRadius: 16,
    border: '1px dashed #e2e8f0',
    boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
  },
  aiButton: {
    marginTop: theme.spacing(3),
    backgroundColor: '#34445c', // Your brand slate
    color: '#fff',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 24px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#1e293b',
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: '#94a3b8',
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: '#e2e8f0',
    },
    '& span': {
      padding: '0 10px',
      fontSize: '0.7rem',
      fontWeight: 700,
      textTransform: 'uppercase',
    }
  }
}));

const WorkflowEmptyState = ({ activeStep, onAutoGenerate }) => {
  const classes = useStyles();
  console.log({activeStep})
  // Map step keys to readable names
  const stepNames = {
    database_profile: "Database Model",
    view: "Views",
    transaction: "Transaction",
    simulation: "Testsuites"
  };

  const currentName = stepNames[activeStep] || "this entity";

  return (
    <Box className={classes.emptyContainer}>
      <Box className={classes.actionCard}>
        <img src="/node_icons/ai.png" style={{width: '3rem'}} alt="hyperblox agent"/>
        
        <Typography variant="h6" style={{ fontWeight: 800, color: '#1e293b' }}>
          Generate {currentName}
        </Typography>
        
        <Button 
          variant="contained" 
          className={classes.aiButton}
          onClick={onAutoGenerate}
          startIcon={<FlashOnIcon style={{ color: '#ffea00' }} />}
        >
          Auto-Generate with Context
        </Button>

        <Box className={classes.divider}>
          <span>Or</span>
        </Box>

        <Typography variant="body2" style={{ color: '#64748b', textAlign: 'center', marginTop: 8 }}>
          Refine the architecture by entering a prompt below, or let the AI build it automatically using your app context.
        </Typography>
        
      </Box>
    </Box>
  );
};

export default WorkflowEmptyState;